import numeral from 'numeral';
import moment from 'moment-msdate';
import deepmerge from 'deepmerge';
var currenciesMap = [{
  "name": "Albania Lek",
  "code": "ALL",
  "unicodes": [76, 101, 107]
}, {
  "name": "Afghanistan Afghani",
  "code": "AFN",
  "unicodes": [1547]
}, {
  "name": "Argentina Peso",
  "code": "ARS",
  "unicodes": [36]
}, {
  "name": "Aruba Guilder",
  "code": "AWG",
  "unicodes": [402]
}, {
  "name": "Australia Dollar",
  "code": "AUD",
  "unicodes": [36]
}, {
  "name": "Azerbaijan New Manat",
  "code": "AZN",
  "unicodes": [1084, 1072, 1085]
}, {
  "name": "Bahamas Dollar",
  "code": "BSD",
  "unicodes": [36]
}, {
  "name": "Barbados Dollar",
  "code": "BBD",
  "unicodes": [36]
}, {
  "name": "Belarus Ruble",
  "code": "BYR",
  "unicodes": [112, 46]
}, {
  "name": "Belize Dollar",
  "code": "BZD",
  "unicodes": [66, 90, 36]
}, {
  "name": "Bermuda Dollar",
  "code": "BMD",
  "unicodes": [36]
}, {
  "name": "Bolivia Boliviano",
  "code": "BOB",
  "unicodes": [36, 98]
}, {
  "name": "Bosnia and Herzegovina Convertible Marka",
  "code": "BAM",
  "unicodes": [75, 77]
}, {
  "name": "Botswana Pula",
  "code": "BWP",
  "unicodes": [80]
}, {
  "name": "Bulgaria Lev",
  "code": "BGN",
  "unicodes": [1083, 1074]
}, {
  "name": "Brazil Real",
  "code": "BRL",
  "unicodes": [82, 36]
}, {
  "name": "Brunei Darussalam Dollar",
  "code": "BND",
  "unicodes": [36]
}, {
  "name": "Cambodia Riel",
  "code": "KHR",
  "unicodes": [6107]
}, {
  "name": "Canada Dollar",
  "code": "CAD",
  "unicodes": [36]
}, {
  "name": "Cayman Islands Dollar",
  "code": "KYD",
  "unicodes": [36]
}, {
  "name": "Chile Peso",
  "code": "CLP",
  "unicodes": [36]
}, {
  "name": "China Yuan Renminbi",
  "code": "CNY",
  "unicodes": [165]
}, {
  "name": "Colombia Peso",
  "code": "COP",
  "unicodes": [36]
}, {
  "name": "Costa Rica Colon",
  "code": "CRC",
  "unicodes": [8353]
}, {
  "name": "Croatia Kuna",
  "code": "HRK",
  "unicodes": [107, 110]
}, {
  "name": "Cuba Peso",
  "code": "CUP",
  "unicodes": [8369]
}, {
  "name": "Czech Republic Koruna",
  "code": "CZK",
  "unicodes": [75, 269]
}, {
  "name": "Denmark Krone",
  "code": "DKK",
  "unicodes": [107, 114]
}, {
  "name": "Dominican Republic Peso",
  "code": "DOP",
  "unicodes": [82, 68, 36]
}, {
  "name": "East Caribbean Dollar",
  "code": "XCD",
  "unicodes": [36]
}, {
  "name": "Egypt Pound",
  "code": "EGP",
  "unicodes": [163]
}, {
  "name": "El Salvador Colon",
  "code": "SVC",
  "unicodes": [36]
}, {
  "name": "Estonia Kroon",
  "code": "EEK",
  "unicodes": [107, 114]
}, {
  "name": "Euro Member Countries",
  "code": "EUR",
  "unicodes": [8364]
}, {
  "name": "Falkland Islands (Malvinas Pound",
  "code": "FKP",
  "unicodes": [163]
}, {
  "name": "Fiji Dollar",
  "code": "FJD",
  "unicodes": [36]
}, {
  "name": "Ghana Cedi",
  "code": "GHC",
  "unicodes": [162]
}, {
  "name": "Gibraltar Pound",
  "code": "GIP",
  "unicodes": [163]
}, {
  "name": "Guatemala Quetzal",
  "code": "GTQ",
  "unicodes": [81]
}, {
  "name": "Guernsey Pound",
  "code": "GGP",
  "unicodes": [163]
}, {
  "name": "Guyana Dollar",
  "code": "GYD",
  "unicodes": [36]
}, {
  "name": "Honduras Lempira",
  "code": "HNL",
  "unicodes": [76]
}, {
  "name": "Hong Kong Dollar",
  "code": "HKD",
  "unicodes": [36]
}, {
  "name": "Hungary Forint",
  "code": "HUF",
  "unicodes": [70, 116]
}, {
  "name": "Iceland Krona",
  "code": "ISK",
  "unicodes": [107, 114]
}, {
  "name": "India Rupee",
  "code": "INR",
  "unicodes": [8377]
}, {
  "name": "India Rupee",
  "code": "INR",
  "unicodes": [96]
}, {
  "name": "Indonesia Rupiah",
  "code": "IDR",
  "unicodes": [82, 112]
}, {
  "name": "Iran Rial",
  "code": "IRR",
  "unicodes": [65020]
}, {
  "name": "Isle of Man Pound",
  "code": "IMP",
  "unicodes": [163]
}, {
  "name": "Israel Shekel",
  "code": "ILS",
  "unicodes": [8362]
}, {
  "name": "Jamaica Dollar",
  "code": "JMD",
  "unicodes": [74, 36]
}, {
  "name": "Japan Yen",
  "code": "JPY",
  "unicodes": [165]
}, {
  "name": "Jersey Pound",
  "code": "JEP",
  "unicodes": [163]
}, {
  "name": "Kazakhstan Tenge",
  "code": "KZT",
  "unicodes": [1083, 1074]
}, {
  "name": "Korea (North Won",
  "code": "KPW",
  "unicodes": [8361]
}, {
  "name": "Korea (South Won",
  "code": "KPW",
  "unicodes": [8361]
}, {
  "name": "Kyrgyzstan Som",
  "code": "KGS",
  "unicodes": [1083, 1074]
}, {
  "name": "Laos Kip",
  "code": "LAK",
  "unicodes": [8365]
}, {
  "name": "Latvia Lat",
  "code": "LVL",
  "unicodes": [76, 115]
}, {
  "name": "Lebanon Pound",
  "code": "LBP",
  "unicodes": [163]
}, {
  "name": "Liberia Dollar",
  "code": "LRD",
  "unicodes": [36]
}, {
  "name": "Lithuania Litas",
  "code": "LTL",
  "unicodes": [76, 116]
}, {
  "name": "Macedonia Denar",
  "code": "MKD",
  "unicodes": [1076, 1077, 1085]
}, {
  "name": "Malaysia Ringgit",
  "code": "MYR",
  "unicodes": [82, 77]
}, {
  "name": "Mauritius Rupee",
  "code": "MUR",
  "unicodes": [8360]
}, {
  "name": "Mexico Peso",
  "code": "MXN",
  "unicodes": [36]
}, {
  "name": "Mongolia Tughrik",
  "code": "MNT",
  "unicodes": [8366]
}, {
  "name": "Mozambique Metical",
  "code": "MZN",
  "unicodes": [77, 84]
}, {
  "name": "Namibia Dollar",
  "code": "NAD",
  "unicodes": [36]
}, {
  "name": "Nepal Rupee",
  "code": "NPR",
  "unicodes": [8360]
}, {
  "name": "Netherlands Antilles Guilder",
  "code": "ANG",
  "unicodes": [402]
}, {
  "name": "New Zealand Dollar",
  "code": "NZD",
  "unicodes": [36]
}, {
  "name": "Nicaragua Cordoba",
  "code": "NIO",
  "unicodes": [67, 36]
}, {
  "name": "Nigeria Naira",
  "code": "NGN",
  "unicodes": [8358]
}, {
  "name": "Norway Krone",
  "code": "NOK",
  "unicodes": [107, 114]
}, {
  "name": "Oman Rial",
  "code": "OMR",
  "unicodes": [65020]
}, {
  "name": "Pakistan Rupee",
  "code": "PKR",
  "unicodes": [8360]
}, {
  "name": "Panama Balboa",
  "code": "PAB",
  "unicodes": [66, 47, 46]
}, {
  "name": "Paraguay Guarani",
  "code": "PYG",
  "unicodes": [71, 115]
}, {
  "name": "Peru Nuevo Sol",
  "code": "PEN",
  "unicodes": [83, 47, 46]
}, {
  "name": "Philippines Peso",
  "code": "PHP",
  "unicodes": [8369]
}, {
  "name": "Poland Zloty",
  "code": "PLN",
  "unicodes": [122, 322]
}, {
  "name": "Qatar Riyal",
  "code": "QAR",
  "unicodes": [65020]
}, {
  "name": "Romania New Leu",
  "code": "RON",
  "unicodes": [108, 101, 105]
}, {
  "name": "Russia Ruble",
  "code": "RUB",
  "unicodes": [1088, 1091, 1073]
}, {
  "name": "Saint Helena Pound",
  "code": "SHP",
  "unicodes": [163]
}, {
  "name": "Saudi Arabia Riyal",
  "code": "SAR",
  "unicodes": [65020]
}, {
  "name": "Serbia Dinar",
  "code": "RSD",
  "unicodes": [1044, 1080, 1085, 46]
}, {
  "name": "Seychelles Rupee",
  "code": "SCR",
  "unicodes": [8360]
}, {
  "name": "Singapore Dollar",
  "code": "SGD",
  "unicodes": [36]
}, {
  "name": "Solomon Islands Dollar",
  "code": "SBD",
  "unicodes": [36]
}, {
  "name": "Somalia Shilling",
  "code": "SOS",
  "unicodes": [83]
}, {
  "name": "South Africa Rand",
  "code": "ZAR",
  "unicodes": [82]
}, {
  "name": "Sri Lanka Rupee",
  "code": "LKR",
  "unicodes": [8360]
}, {
  "name": "Sweden Krona",
  "code": "SEK",
  "unicodes": [107, 114]
}, {
  "name": "Switzerland Franc",
  "code": "CHF",
  "unicodes": [67, 72, 70]
}, {
  "name": "Suriname Dollar",
  "code": "SRD",
  "unicodes": [36]
}, {
  "name": "Syria Pound",
  "code": "SYP",
  "unicodes": [163]
}, {
  "name": "Taiwan New Dollar",
  "code": "TWD",
  "unicodes": [78, 84, 36]
}, {
  "name": "Thailand Baht",
  "code": "THB",
  "unicodes": [3647]
}, {
  "name": "Trinidad and Tobago Dollar",
  "code": "TTD",
  "unicodes": [84, 84, 36]
}, {
  "name": "Turkey Lira (New)",
  "code": "TRY",
  "unicodes": [89, 84, 76]
}, {
  "name": "Turkey Lira",
  "code": "TRL",
  "unicodes": [8356]
}, {
  "name": "Tuvalu Dollar",
  "code": "TVD",
  "unicodes": [36]
}, {
  "name": "Ukraine Hryvnia",
  "code": "UAH",
  "unicodes": [8372]
}, {
  "name": "United Kingdom Pound",
  "code": "GBP",
  "unicodes": [163]
}, {
  "name": "United States Dollar",
  "code": "USD",
  "unicodes": [36]
}, {
  "name": "Uruguay Peso",
  "code": "UYU",
  "unicodes": [36, 85]
}, {
  "name": "Uzbekistan Som",
  "code": "UZS",
  "unicodes": [1083, 1074]
}, {
  "name": "Venezuela Bolivar",
  "code": "VEF",
  "unicodes": [66, 115]
}, {
  "name": "Viet Nam Dong",
  "code": "VND",
  "unicodes": [8363]
}, {
  "name": "Yemen Rial",
  "code": "YER",
  "unicodes": [65020]
}, {
  "name": "Zimbabwe Dollar",
  "code": "ZWD",
  "unicodes": [90, 36]
}];

/**
 * A representation of some information from the ISO currency codes, plus display information and logic
 * @ignore
 */
var Currency = /** @class */function () {
  /**
   * A representation of some information from the ISO currency codes, plus display information and logic
   * @param {ICurrency} obj An object that can be stored and retrieved as a POJO that represents the currency.
   */
  function Currency(obj) {
    this.name = obj.name;
    this.code = obj.code;
    this.unicodes = obj.unicodes;
  }
  /**
   * Turns the internal unicode array into a string of HTML numeric character references
   * @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Entity }
   */
  Currency.prototype.toHtmlEncoding = function () {
    return String.prototype.concat.apply('', this.unicodes.map(this.codeToChar));
  };
  Currency.prototype.codeToChar = function (unicode) {
    return "&#" + unicode + ";";
  };
  return Currency;
}();
/** @ignore */
var CurrencyDictionary = /** @class */function () {
  /**
   * A dictionary of currencies keyed off the currency code
   * @param {ICurrency[]} _currenciesMap
   */
  function CurrencyDictionary(_currenciesMap) {
    var _this = this;
    _currenciesMap.forEach(function (currencysObj) {
      var currency = new Currency(currencysObj);
      _this[currency.code] = currency;
    }, this);
  }
  return CurrencyDictionary;
}();
var CurrencyDictionary$1 = new CurrencyDictionary(currenciesMap);

/** Default error string to display for invalid values.
 * @ignore
 * */
var defaultErrorString = '--';
/** Values considered to be invalid.
 * @ignore
 * */
var invalidValues = [undefined, null, defaultErrorString];
/**
 * Base Format class. Note that the default export of the library returns the format() function.
 */
var Format = /** @class */function () {
  /** Create an instance of Format, with optional global options. */
  function Format(options) {
    var defaults = {
      dateFormat: 'L',
      errorString: defaultErrorString,
      inputTimezone: null,
      percentModifier: 1,
      precision: {
        number: 0,
        percent: 2,
        price: 2
      },
      showNegAsParentheses: false,
      showSign: false,
      timeFormat: 'LT'
    };
    this.options = options ? deepmerge(defaults, options) : defaults;
    // Update the default null returns to the default error string
    this.numeral.nullFormat(this.options.errorString);
    this.moment.updateLocale(moment.locale(), {
      invalidDate: this.options.errorString
    });
  }
  Object.defineProperty(Format.prototype, "numeral", {
    /** Instance of `numeral` available for use */
    get: function () {
      return numeral;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Format.prototype, "moment", {
    /** Instance of `moment-msdate` with `moment-timezone` available for use */
    get: function () {
      return moment;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Format.prototype, "timeOffsetRegex", {
    /** @ignore */
    get: function () {
      return /( |T)[\d:.]+([-+][\d:]+)$|( [-+]\d{4})$|( ?[A-Za-z]+$)|( [A-Za-z]+-\d{4})/;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Format a number string to a thousands-delimited (,) number. Defaults to 0 decimal precision.
   * @param input - Input value
   * @param [precision] - Output decimal precision
   * @param [options]
   * @param {boolean} [options.showSign] Prepend +/- sign to formatted number
   * @param {boolean} [options.showNegAsParentheses] Use parantheses to indicate negative numbers
   * @param {boolean} [options.showMagnitude] Add magnitude markers -  k (thousands), m (millions),
   * etc - to end of string, before percent symbol
   * @returns {string} - Formatted number string
   * @example
   * ```
   * format().number(109282) // 109,282
   * format().number(109282, 4) // 109,282.0000
   * format().number(-100, null, { showNegAsParentheses: true }) // (100)
   * ```
   */
  Format.prototype.number = function (input, precision, options) {
    var parsedValue = numeral(input).value();
    // return errorString if invalid value,
    // or numeral(x).value() is null
    if (invalidValues.includes(input) || parsedValue === null) {
      return this.options.errorString;
    }
    var showSign = options && options.showSign || this.options.showSign;
    var showNegAsParentheses = parsedValue !== 0 && (options && options.showNegAsParentheses || this.options.showNegAsParentheses);
    var showMagnitude = options && options.showMagnitude || false;
    // build precision string to pass to numeral.format
    var precisionString = '';
    if (parsedValue) {
      if (precision !== undefined && precision !== null) {
        precisionString = this.getPrecision(precision);
      } else {
        precisionString = this.getPrecision(this.options.precision.number);
      }
    }
    var magnitudeString = showMagnitude ? ' a' : '';
    // build numeral format string
    // format = '(+0,0.00), etc.'
    var format;
    if (showNegAsParentheses) {
      format = "(0,0." + precisionString + magnitudeString + ")";
    } else {
      var signString = showSign ? '+' : '';
      format = signString + "0,0." + precisionString + magnitudeString;
    }
    return this.numeral(input).format(format);
  };
  /**
   * Format a number string to a thousands-delimited (,) percent. Expects decimal notation.
   * Defaults to 2 decimal precision.
   *
   * @param {*} input - Input value
   * @param {number} [precision] - Output decimal precision
   * @param {PercentOptions} [options]
   * @param {boolean} [options.showSign] Prepend +/- sign to formatted number
   * @param {boolean} [options.showNegAsParentheses] Use parantheses to indicate negative numbers
   * @param {boolean} [options.showMagnitude] Add magnitude markers -  k (thousands), m (millions),
   * etc - to end of string, before percent symbol
   * @param {number} [options.percentModifier] Amount to multiply input values by in order
   * to noramlize them to decimal notation. Set this to 0.01 if input values are already
   * in percent form. Default: 1, or value provided to options.percentModifier.
   * @returns {string} - Formatted percent string
   * @example
   * ```
   * format().percent(0.1) // 10%
   * format().percent(100, 1, { percentModifier: 0.01 }) // 100.0%
   * ```
   */
  Format.prototype.percent = function (input, precision, options) {
    var parsedValue = numeral(input).value();
    // return errorString ('--') if invalid value,
    // or numeral(x).value() is null
    if (invalidValues.includes(input) || parsedValue === null) {
      return this.options.errorString;
    }
    var showSign = options && options.showSign || this.options.showSign;
    var showNegAsParentheses = parsedValue !== 0 && (options && options.showNegAsParentheses || this.options.showNegAsParentheses);
    var showMagnitude = options && options.showMagnitude || false;
    var modifier = options && options.percentModifier !== undefined ? options.percentModifier : this.options.percentModifier;
    // percentModifier should be above 0 to prevent confusion,
    // and random 0 / negative values
    if (modifier <= 0) {
      throw new Error("[format.percent] percentModifier option must be above 0");
    }
    // build precision string to pass to numeral.format
    var precisionString = '';
    if (parsedValue) {
      if (precision !== undefined && precision !== null) {
        precisionString = this.getPrecision(precision);
      } else {
        precisionString = this.getPrecision(this.options.precision.percent);
      }
    }
    var magnitudeString = showMagnitude ? 'a' : '';
    // build numeral format string
    // format = '(+0,0.00%), etc.'
    var format;
    if (showNegAsParentheses) {
      format = "(0,0." + precisionString + magnitudeString + "%)";
    } else {
      var signString = showSign ? '+' : '';
      format = signString + "0,0." + precisionString + magnitudeString + "%";
    }
    // apply percent modifier
    var _input = parsedValue * modifier;
    return this.numeral(_input).format(format);
  };
  /**
   * Format a number string to a thousands-delimited (,) price. Defaults to 2 decimal precision or
   * the input's number of significant figures, whichever is greater, without rounding.
   * @param {string} input Input value
   * @param {number} [precision] Output decimal precision
   * @param {PriceOptions} [options]
   * @param {string} [options.currencyISO] ISO 4217 code to use for the currency symbol; defaults to
   * USD. Will be pre- or suffixed appropriately for that locale.
   * @param {boolean} [options.hideCurrencySymbol] Hide the currency symbol
   * @param {boolean} [options.showSign] Prepend +/- sign to formatted number
   * @param {boolean} [options.showNegAsParentheses] Use parantheses to indicate negative numbers
   * @param {boolean} [options.showMagnitude] Add magnitude markers (k (thousands), m (millions),
   * etc) to end of string
   * @returns {string} Formatted price string
   * @example
   * ```
   * format().price(12345) // $12,345.00
   * format().price(12.10933) // $12.10933
   * format().price(12.10933, 4) // $12.1093
   * format().price(13500, 2, { currencyISO: 'JPY' }) //  ¥13,500.00
   * ```
   */
  Format.prototype.price = function (input, precision, options) {
    var parsedValue = numeral(input).value();
    // return errorString if invalid value,
    // or numeral(x).value() is null
    if (invalidValues.includes(input) || parsedValue === null) {
      return this.options.errorString;
    }
    var showSign = options && options.showSign || this.options.showSign;
    var showNegAsParentheses = parsedValue !== 0 && (options && options.showNegAsParentheses || this.options.showNegAsParentheses);
    var showMagnitude = options && options.showMagnitude || false;
    // allow users to set the currency symbol, with the currencyISO taking precedence if both are set
    var currencySymbol = options && options.currencySymbol || '$';
    if (options && options.currencyISO && CurrencyDictionary$1.hasOwnProperty(options.currencyISO)) {
      currencySymbol = CurrencyDictionary$1[options.currencyISO].toHtmlEncoding();
    }
    // hide symbol if hideCurrencySymbol is set to true
    if (options && options.hideCurrencySymbol) {
      currencySymbol = '';
    }
    // build precision string to pass to numeral.format
    var precisionString = '';
    if (parsedValue) {
      // use precision param
      if (precision !== undefined && precision !== null) {
        precisionString = this.getPrecision(precision);
        // drop precision for values larger than 1,000
      } else if (parsedValue >= 1000) {
        precisionString = '';
        // otherwise, use default precision option, with optional zeros
        // default: 00[00]
      } else {
        precisionString = this.getPrecision(this.options.precision.price, 2);
      }
    }
    var magnitudeString = showMagnitude ? ' a' : '';
    var absValue = Math.abs(parsedValue);
    // use absolute value to avoid putting +/- signs in the wrong place
    var formattedValue = "" + currencySymbol + this.numeral(absValue).format("0,0." + precisionString + magnitudeString, Math.floor);
    if (parsedValue > 0 && showSign && !showNegAsParentheses) {
      return "+" + formattedValue;
    } else if (parsedValue < 0) {
      return showNegAsParentheses ? "(" + formattedValue + ")" : "-" + formattedValue;
    } else {
      return formattedValue;
    }
  };
  /**
   * Format an input to a date string. Defaults to 'L'. See https://momentjs.com/docs/#/displaying/format/
   * for more information about formatting tokens.
   * @param {*} input - ISO 8601 or RFC 2822 date/time format string, i.e. any value that moment.js accepts
   * @param {string} [format] -  String used to format dates. See https://momentjs.com/docs/#/displaying/format/
   * @param {DateTimeOptions} [options]
   * @example
   * ```
   * // Assuming America/Denver
   * format().date('2019-01-01') // 1/1/2019
   * format().date('2019-01-01', 'YYYY') // 2019
   * format().date('42298.6868055556', null, { isMSDate: true }) // 10/21/2015
   * ```
   */
  Format.prototype.date = function (input, format, options) {
    var formatString = format || this.options.dateFormat;
    return this.dateTime.call(this, input, formatString, options);
  };
  /**
   * Format an input to a time string. Defaults to 'LT'. See https://momentjs.com/docs/#/displaying/format/
   * for more information about formatting tokens.
   * @param {*} input - ISO 8601 or RFC 2822 date/time format string, i.e. any value that moment.js accepts
   * @param {string} [format] -  String used to format dates. See https://momentjs.com/docs/#/displaying/format/
   * @param {DateTimeOptions} [options]
   * @example
   * ```
   * // Assuming America/Denver
   * format().time('2019-01-01T12:00+02:00') // 3:00 AM
   * format().time('2000-12-25T00:00:00', 'LLLL', {
   *   inputTimezone: 'Pacific/Easter'
   * }) //  Sunday, December 24, 2000 10:00 PM
   * ```
   */
  Format.prototype.time = function (input, format, options) {
    var formatString = format || this.options.timeFormat;
    return this.dateTime.call(this, input, formatString, options);
  };
  /**
   * Format a datetime to a string; an alias for [[Format.date]] and [[Format.time]]
   * @param {*} input - ISO 8601 or RFC 2822 date/time format string, i.e. any value that moment.js accepts
   * @param {string} [format] -  String used to format dates. See https://momentjs.com/docs/#/displaying/format/
   * @param {DateTimeOptions} [options]
   * @returns {string}
   * @example
   * ```
   *  format().date('2019-01-01', 'LL')
   * ```
   */
  Format.prototype.dateTime = function (input, format, options) {
    // Return error string if the input matches any invalid values
    if (invalidValues.includes(input)) {
      return this.options.errorString;
    }
    var inputTimezone = options && options.inputTimezone ? options.inputTimezone : this.options.inputTimezone;
    var outputTimezone = options && options.outputTimezone ? options.outputTimezone : null;
    var isMSDate = options && options.isMSDate ? options.isMSDate : false;
    var preserveOffset = options && options.preserveOffset ? options.preserveOffset : false;
    // Test UTC offset in ISO and RFC:
    // https://regexr.com/4ia1t
    // 1. ( |T)[\d:.]+([-+][\d:]+)$ -- test for ISO offset (±00:00)
    // 2. ( [-+]\d{4})$             -- test for RFC 4-digit offset (zone)
    // 3. ( ?[A-ia-iK-Zk-z]+)$      -- test for RFC obs-zone / ISO Z
    var hasOffset = this.timeOffsetRegex.test(input);
    var momentDate;
    // Handle MSDates, which are unambiguous
    if (isMSDate) {
      momentDate = this.moment(this.moment.fromOADate(input).format()); // returns UTC offset date
      // Any ISO/RFC offset or RFC zone? --> use moment()
      // Need to preserve the offset (not convert to local time) --> use moment.parseZone()
    } else if (hasOffset) {
      momentDate = preserveOffset ? this.moment.parseZone(input) : this.moment(input);
      // All other date inputs
    } else {
      // Set the inputTimezone if provided
      momentDate = inputTimezone !== undefined && inputTimezone !== null ? this.moment.tz(input, inputTimezone) : this.moment(input);
    }
    // Return dates that are to be converted to an outputTimezone, with
    // preserveOffset being overridden by outputTimezone
    if (outputTimezone) {
      return momentDate.tz(outputTimezone).format(format);
    }
    // Ambiguous times that are interpreted by inputTimezone should be
    // formatted to local time when outputTimezone is not provided -
    // we parse the momentDate (which is in the inputTimezone) in order to achieve this,
    // otherwise it will return in the inputTimezone (does your head hurt yet?)
    if (!hasOffset && inputTimezone) {
      return this.moment(momentDate.format()).format(format);
    }
    return momentDate.format(format);
  };
  /**
   * Get a precision string in 0's to be passed to numeral.format()
   * based on the number (precision) passed in
   *
   * @private
   * @param {number} precision Number of 0's in the string returned
   * @param {number} optional Number of 0's to optionally show
   * @example
   *  getPrecision(4) // '0000'
   *  getPrecision(2, 2) // '00[00]'
   */
  Format.prototype.getPrecision = function (precision, optional) {
    var precisionZeros = Array(precision).fill(0).join('');
    if (optional !== undefined) {
      var optionalZeros = Array(optional).fill(0).join('');
      return precisionZeros + "[" + optionalZeros + "]";
    } else {
      return "" + precisionZeros;
    }
  };
  return Format;
}();
/**
 * Default export. Returns an instance of the Format class.
 * Takes global options in the form of [[FormatOptions]].
 *
 * @param {FormatOptionsProperty} [options]
 * @returns {Format}
 */
function format(options) {
  return new Format(options);
}
/**
 * Returns the current locale's language code
 *
 * @returns {string} - language tag of current locale
 */
format.locale = 'en';
/**
 * Set the current locale by passing in a language tag.
 * See https://www.w3.org/International/questions/qa-choosing-language-tags.
 * Remember that you have to import Numeral's locales manually, e.g. import 'numeral/locales/fr'
 * If the locale is unavailable in `moment` or `numeral`, register it with registerLocale
 * @example
 * ```
 * import 'numeral/locales/fr';
 * format.setLocale('fr');
 * ```
 *
 * @param {string} locale - Language tag of locale
 */
format.setLocale = function (locale) {
  if (!locale || !locale.length) {
    return;
  }
  var oldLocale = this.locale;
  // Since moment will not allow unregistered locales and reverts to the
  // last valid locale, throw helpful error if the attempted locale change cannot be done
  if (moment.locale(locale) !== locale) {
    this.setLocale(oldLocale);
    throw new Error("[Format] - Failed to change locale; " + locale + " has not been registered with registerLocale yet");
  }
  this.locale = locale;
  numeral.locale(locale);
};
/**
 * Register a new moment and numeral locale. See `moment` and `numeral`'s documentation for more
 * information on how to define a locale: https://momentjs.com/docs/#/i18n/adding-locale/ and
 * http://numeraljs.com/#locales
 * @example
 * ```
 * format.registerLocale('lang-tag', { ... }, { ... });
 * ```
 *
 * @param {string} locale - Language tag of locale
 * @param {LocaleSpecification} momentLocale - `moment` locale definition
 * @param {NumeralJSLocale|NumeralJsFormat} numeralLocale - `numeral` locale definition
 */
format.registerLocale = function (locale, momentLocale, numeralLocale) {
  if (!locale || !locale.length) {
    throw new Error('[Format] registerLocale: Locale language tag must be provided');
  }
  numeral.register('locale', locale, numeralLocale);
  moment.locale(locale, momentLocale);
  // reset moment to the last used locale to prevent registration from also switching locales
  moment.locale(this.locale);
};
/**
 * Extends the library with custom methods. Expects an object where keys are method names and values are the corresponding functions.
 * You can use all of the library's methods - like number(), percent(), myCustomMethod() - within custom methods. *
 * `this` = Format instance, i.e. this.number(...)
 *
 * @param {...ExtendMethodsMap[]} args (1 or more) objects containing functions
 */
format.extend = function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var extensions = Object.assign.apply(Object, [{}].concat(args));
  Object.keys(extensions).forEach(function (method) {
    Format.prototype[method] = extensions[method];
  });
};
export default format;
export { Format };